import { ADDFLIGHT, REMOVEFLIGHT } from './actionTypes';

const initialState = [];

const flightReducer = (state = initialState, action) => {
    switch(action.type) {
        case ADDFLIGHT: 
            return [
                ...state,
                action.payload
            ];

        case REMOVEFLIGHT:
            let currentFlights = [...state];
            currentFlights = currentFlights.filter(f => f.id !== action.payload);
            return currentFlights;

        default:
            return state;
    }
}

export default flightReducer;